import { cx } from "@suse-o11y/class-variance";
import { toDate } from "@suse-o11y/date-time";
import type { Time } from "@suse-o11y/date-time/time";
import { Tooltip, TooltipBoundary, TooltipTrigger } from "@suse-o11y/tooltip";
import React from "react";

import { Truncated } from "~/components/truncated";

import type { TimeRange } from "../../../app/state/view/timeline/TimeRange";

import { ComponentLink } from "./ComponentLink";

export interface ComponentLinkWithTypeProps {
	className?: string;
	name: string;
	identifier: string;
	type: string;
	timestamp: undefined | Time;
	timeRange: undefined | TimeRange;
	prefix?: React.ReactNode;
	onClick?: VoidFunction;
}

export const ComponentLinkWithType: React.FC<ComponentLinkWithTypeProps> = ({
	name,
	identifier,
	type,
	timestamp,
	timeRange,
	prefix,
	onClick,
	className,
	...props
}) => (
	<div {...props} className={cx("flex min-w-0 grow flex-row flex-nowrap gap-1", className)}>
		{prefix}
		<div className="min-w-0 max-w-3/4">
			<TooltipBoundary>
				<TooltipTrigger asChild>
					<ComponentLink
						className="min-w-0"
						componentIdentifier={identifier}
						onClick={onClick}
						search={{
							timestamp: toDate(timestamp),
							timeRange,
						}}
						text={name}
						tooltip={false}
					/>
				</TooltipTrigger>

				<Tooltip className="tooltip/tooltip">
					<div className="mb-1.5 font-medium text-sm/4">Component</div>
					{name}
					<div className="mt-2 mb-1.5 font-medium text-sm/4">Type</div>
					{type}
				</Tooltip>
			</TooltipBoundary>
		</div>

		<Truncated className="flex-[1_1_0]" tooltip={type} truncate="middle">{`(${type})`}</Truncated>
	</div>
);
